import {
  HeartHandshake, Baby, Ribbon, Home, MessagesSquare, Sprout,
  Users, Trophy, Droplets, Leaf, GraduationCap, Heart,
} from "lucide-react";

const MAP = {
  HeartHandshake, Baby, Ribbon, Home, MessagesSquare, Sprout,
  Users, Trophy, Droplets, Leaf, GraduationCap, Heart,
};

export default function Icon({ name, className = "h-6 w-6", ...rest }) {
  const Cmp = MAP[name] || Heart;
  return <Cmp className={className} {...rest} />;
}
